import Icon from '../components/Icon.vue'

Icon.register({
  bone: {
    width: 640,
    height: 512,
    paths: [
      {
        d: 'M598.9 244.6c-9.4 4.7-9.4 18.2 0 22.9 25.2 12.6 41.1 38.3 41.1 66.5v7.6c0 41.1-33.3 74.4-74.4 74.4-32 0-60.4-20.5-70.6-50.9-6.5-19.6-10.7-45.1-38.1-45.1h-273.9c-26.5 0-30.4 22.1-38.1 45.1-10.1 30.4-38.5 50.9-70.6 50.9-41.1 0-74.4-33.3-74.4-74.4v-7.6c0-28.2 15.9-53.9 41.1-66.5 9.4-4.7 9.4-18.2 0-22.9-25.2-12.6-41.1-38.4-41.1-66.5v-7.6c0-41.1 33.3-74.4 74.4-74.4 32 0 60.4 20.5 70.6 50.9 6.5 19.6 10.7 45.1 38.1 45.1h273.9c26.5 0 30.4-22.1 38.1-45.1 10.1-30.4 38.5-50.9 70.6-50.9 41.1 0 74.4 33.3 74.4 74.4v7.6c0 28.2-15.9 53.9-41.1 66.5z'
      }
    ]
  }
})



//////////////////
// WEBPACK FOOTER
// ./~/vue-awesome/icons/bone.js
// module id = 672
// module chunks = 0